const Formats = {
	Phone:"(###) ### ####"
};

export {Formats};